module.exports = __webpack_public_path__ + "img/themify.cba68f98.svg";